<template>
  <div class="module">
    <div class="item" @click="insert('title')">
      <h1>正文标题</h1>
    </div>
    <div class="item" @click="insert('text')">
      <p>正文内容</p>
    </div>
    <div class="item" @click="insert('img')">
<!--      <div style="width: 100px;height: 200px; background:url('../../assets/ex.jpg') center no-repeat ;"></div>-->
<!--      <img src="../../assets/ex.jpg" alt="">-->
      <p>插入图片</p>
    </div>
    <div class="item" >
      <el-upload class="upload-demo" multiple
                 :http-request="img_upload" :before-upload="upload_check" accept="image/*"
                 :show-file-list="false">
        <p>插入多张图片</p>
      </el-upload>
    </div>
    <div class="item" style="position: relative" @click="insert('swiper')">
      <p>插入轮播图</p>
    </div>
    <div class="item" style="position: relative" @click="insert('video')">
      <p>插入视频</p>
    </div>
    <layer-pop title="批量上传图片" v-if="is_multiple" @close="is_multiple=false">
      <multiple v-model="imglist" :list="imglist" :imglist="imglist" @submit="multiple_submit"></multiple>
    </layer-pop>
  </div>
</template>

<script>
import Multiple from "@/components/multiple";
import LayerPop from "@/components/layer-pop.vue";
export default {
  name: "one_page_module",
  components:{LayerPop, Multiple},
  model:{prop:'content' ,event:'change'},
  props:{
    content : {type : String, default : ''},
  },
  data(){
    return{
      dir:[],
      imglist:[],
      is_multiple:false,
    }
  },
  methods:{
    insert:function (type){
      this.$emit('insert',type);
    },
    img_upload:async function (e){
      try {
        console.log(e.file);
        if (e.file){
          this.$_showLoading();
          let res = await this.$_api.upload(e.file,'img','',this.user.uid);
          this.$_hideLoading();
          let data = {type:'img',url:res.url,class:'web_img',item:[],filename:res.filename};
          this.imglist.push(data);
          this.is_multiple = true;
        }
      }catch (e) {
        console.log(e);
        return false;
      }
    },
    upload_check:function (e){
      let that = this;
      console.log(e);
      let check_img = new Promise(function (resolve, reject){
        let _url = window.URL || window.webkitURL;
        let image = new Image();
        image.onload = function (){
          //检查比例
          // if ((image.width / image.height) == (3 / 5)){
          //   that.$_showToastNone('图片宽高比例必须是3:5');
          //   reject();
          // }
          let size = image.size / 1024 / 1024;
          if (size > 3){
            that.$_showToastNone('最大只能上传3M');
            reject();
          }
          resolve();
        }
        image.src = _url.createObjectURL(e);
      })
      return check_img;
    },
    multiple_submit:function (e){
      let that = this;
      that.content = that.content.concat(e);
      that.$emit('change',that.content);
      that.imglist = [];
      that.is_multiple = false;
    }
  }
}
</script>

<style scoped>
.module{
  /*border: 1px solid #dcdfe6;*/
  box-shadow: 0 0 5px #dcdfe6;
  border-radius: 5px;
  padding: 20px 10px;
  width: 320px;
  height: auto;
  overflow: auto;
}
.item{
  border: 1px dashed #dcdfe6;
  text-align: center;
  padding: 10px;
  margin: 10px;
  cursor: pointer;
}
.item:hover{
  color: #409eff;border: 1px dashed #409eff;
}
.item img{
  width: 100%;
}
</style>